import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSocket } from "../context/SocketContext";
import { addIncomingCall, removeCall } from "../redux/slices/sipSlice";
import { AppDispatch } from "../redux/store";
import { processedCallIds } from "../redux/slices/sipSlice";
import { api } from "../redux/services/api";

interface CallSocketMessageData {
  type: "INC_CALL" | "MISSEDCALL" | string;
  callId: string;
  phoneNumber?: string;
  callUUID?: string;
  ringTimeout?: string;
}

interface CallSocketNotification {
  message?: {
    data?: CallSocketMessageData;
  };
}

const SipSocketBridge = () => {
  const { socket } = useSocket();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (!socket) return;

    const handleCallNotification = (
      msg: CallSocketNotification,
      ack?: (success: boolean) => void,
    ) => {
      if (typeof ack === "function") {
        ack(true);
      }
      const data = msg?.message?.data;
      if (!data?.callId) return;

      if (data?.type === "INC_CALL") {
        if (processedCallIds.has(data.callId)) {
          return;
        }
        processedCallIds.add(data.callId);
        const timeout = parseInt(data?.ringTimeout || "30", 10) * 1000;
        setTimeout(() => processedCallIds.delete(data.callId), timeout + 10000);

        dispatch(
          addIncomingCall({
            id: data.callId,
            info: `sip:${data?.phoneNumber}@server`,
            callUUID: data?.callUUID,
            phoneNumber: data?.phoneNumber,
          }),
        );
      }

      if (data?.type === "MISSEDCALL") {
        processedCallIds.delete(data.callId);
        dispatch(removeCall(data.callId));
        // Invalidate "Calls" tag to refresh the recent calls list
        dispatch(api.util.invalidateTags(["Calls"]));
      }
    };

    socket.on("call_socket_notification", handleCallNotification);

    return () => {
      socket.off("call_socket_notification", handleCallNotification);
    };
  }, [socket, dispatch]);

  return null;
};

export default SipSocketBridge;
